import * as AuthService from '@/services/AuthService';
import { storeInstance as Store } from '@/store';

const keyAdmin = 'admin';
const clientId = process.env.VUE_APP_OPENID_CLIENTID
  ? process.env.VUE_APP_OPENID_CLIENTID
  : null;
export function checkIfExistRole (user, roleToSearch) {
  let existRole = false;
  roleToSearch.forEach(item => {
    if (user.role.includes(item)) {
      existRole = true;
    }
  });
  return existRole;
}

export function isAdminAnyClient () {
  const resourceAccess = AuthService.tokenParsed().resource_access;
  let isAnyAdmin = false;

  Object.keys(resourceAccess).forEach(key => {
    resourceAccess[key].roles.forEach(item => {
      const stringSplit = item.split('_');
      if (stringSplit[stringSplit.length - 1] === keyAdmin) {
        isAnyAdmin = true;
      }
    });
  });
  return isAnyAdmin;
}

export function isSuperAdmin () {
  const resourceAccess = AuthService.tokenParsed().resource_access;
  let isSuperAdmin = false;

  Object.keys(resourceAccess).forEach(key => {
    if (key === clientId) {
      resourceAccess[key].roles.forEach(item => {
        const stringSplit = item.split('_');
        if (stringSplit[stringSplit.length - 1] === keyAdmin) {
          isSuperAdmin = true;
        }
      });
    }
  });
  return isSuperAdmin;
}

export function mutateAdmintoSuperAdmin (value) {
  const positionClientAdmin = value.role.indexOf('admin');
  if (positionClientAdmin === -1) return;
  value.role[positionClientAdmin] = 'superadmin';
}
export async function getEntidadesVisibles () {
  Store.commit('PF/haveEntidadesVisibles', false);
  let request = {
    controller: '/Entidad'
  };

  await Store.dispatch('PF/getSuit', request)
    .then((response) => {
      // comprobar que haya alguna entidad visible en el array
      response.data.forEach(element => {
        if (element.visible === true) {
          // mutamos la propiedad
          Store.commit('PF/haveEntidadesVisibles', true);
        }
      });
    });
}

export async function getEntidadesVisiblesRelated () {
  Store.commit('PF/haveEntidadesVisiblesRelated', false);

  let requestUser = {
    controller: '/EntidadUserRelatedVisible/' + Store.getters['PF/userId']
  };

  await Store.dispatch('PF/getSuit', requestUser)
    .then((response) => {
      Store.commit('PF/haveEntidadesVisiblesRelated', response.data);
    });
}

export async function isAnyEntidadAdmin (user) {
  let request = {
    controller: '/AdminEntidad',
    data: {
      userId: user.nameid,
      PageNumber: 0,
      PageSize: 10
    }
  };

  await Store.dispatch('PF/getSuit', request)
    .then((response) => {
      Store.commit('PF/setIsAdminEntidad', response.data.length > 0);
    });
}

export async function isAnyDeliveryUser (user) {
  let request = {
    controller: '/Authorization/DeliveryUser/Users/' + user.nameid
  };

  await Store.dispatch('PF/getSuit', request)
    .then((response) => {
      Store.commit('PF/setIsDeliveryUser', response.data > 0);
    });
}
